module.exports = __webpack_public_path__ + "img/jamila-rowser.0cfcf3d6.png";